import type { Transition } from "framer-motion";
import { EASE_INTRO } from "../../lib/motion";

export const HERO_TITLE_WORDS = ["Fund.", "Pay.", "Grow."] as const;

/** Word rise — matches the section-two chat title entrance. */
export const HERO_WORD_ENTER_S = 0.9;
export const HERO_WORD_STAGGER_S = 0.2;

/** Subtitle + CTA enter together after the three title beats. */
export const HERO_SIDE_CONTENT_DELAY_S = HERO_TITLE_WORDS.length * HERO_WORD_STAGGER_S;

export const HERO_WORD_HIDDEN = {
	opacity: 0,
	filter: "blur(12px)",
	y: "100%",
	scaleY: 1.35,
	originY: 1,
} as const;

export const HERO_WORD_SHOWN = {
	opacity: 1,
	filter: "blur(0px)",
	y: 0,
	scaleY: 1,
	originY: 1,
} as const;

/** Hero videos: opacity + y only — scale distorts the asset grid during entrance. */
export const HERO_ASSET_HIDDEN = { opacity: 0, y: 28 } as const;
export const HERO_ASSET_SHOWN = { opacity: 1, y: 0 } as const;

export const HERO_SIDE_HIDDEN = { opacity: 0, y: 16, filter: "blur(10px)" } as const;
export const HERO_SIDE_SHOWN = { opacity: 1, y: 0, filter: "blur(0px)" } as const;

/** CTA: opacity + y only — blur on a solid button flickers when the entrance finishes. */
export const HERO_CTA_HIDDEN = { opacity: 0, y: 16 } as const;
export const HERO_CTA_SHOWN = { opacity: 1, y: 0 } as const;

export function heroWordTransition(index: number, reducedMotion: boolean): Transition {
	if (reducedMotion) return { duration: 0 };
	const delay = index * HERO_WORD_STAGGER_S;
	return {
		duration: HERO_WORD_ENTER_S,
		delay,
		ease: EASE_INTRO,
		filter: { duration: HERO_WORD_ENTER_S * 0.3, delay, ease: EASE_INTRO },
		opacity: { duration: HERO_WORD_ENTER_S * 0.8, delay, ease: EASE_INTRO },
	};
}

export function heroAssetTransition(index: number, reducedMotion: boolean): Transition {
	if (reducedMotion) return { duration: 0 };
	const delay = index * HERO_WORD_STAGGER_S;
	return {
		duration: HERO_WORD_ENTER_S,
		delay,
		ease: EASE_INTRO,
	};
}

export function heroSideContentTransition(reducedMotion: boolean): Transition {
	if (reducedMotion) return { duration: 0 };
	return {
		duration: HERO_WORD_ENTER_S,
		delay: HERO_SIDE_CONTENT_DELAY_S,
		ease: EASE_INTRO,
		filter: { duration: HERO_WORD_ENTER_S * 0.3, delay: HERO_SIDE_CONTENT_DELAY_S, ease: EASE_INTRO },
	};
}

export function heroCtaTransition(reducedMotion: boolean): Transition {
	if (reducedMotion) return { duration: 0 };
	return {
		duration: HERO_WORD_ENTER_S,
		delay: HERO_SIDE_CONTENT_DELAY_S,
		ease: EASE_INTRO,
	};
}
